import { useQuery } from '@apollo/client';
import { ContactPageOutlined } from '@mui/icons-material';
import { Widget, WidgetContent, WidgetHeader, WidgetIcon, useScrollIntoView } from '@procureai/ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { DataGridCustom } from '~/components/DataGridCustom';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';
import { useRiskDetail } from '~/modules';

import { useSupplierListGridConfig } from './SupplierListWidget.dataGrid';
import { SUPPLIER_LIST_WIDGET_QUERY } from './SupplierListWidget.gql';

const WIDGET_NAME = 'SupplierListWidget';

export const SupplierListWidget = () => {
  const { id } = useRiskDetail();
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: WIDGET_NAME });
  const [widgetRef, active] = useScrollIntoView({ hash: 'risk-supplier-list' });
  const { data, loading } = useQuery(SUPPLIER_LIST_WIDGET_QUERY, { variables: { id } });
  const config = useSupplierListGridConfig();
  const reports = data?.cataclysm?.risk.suppliers ?? [];
  return (
    <Widget ref={widgetRef} active={active} data-intercom-target={WIDGET_NAME}>
      <WidgetHeader title={t('title')} icon={<WidgetIcon icon={<ContactPageOutlined fontSize="small" />} />} />
      <WidgetContent sx={{ minHeight: 420 }}>
        {!isEmpty(reports) ? (
          <DataGridCustom
            {...config}
            rows={reports}
            getRowId={(row) => row.id}
            pagination={true}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            hideFooter={false}
            pageSizeOptions={[5]}
          />
        ) : loading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget />
        )}
      </WidgetContent>
    </Widget>
  );
};
